import React from 'react'

const SECTIONS = [
  {
    title: '1. Quem somos',
    body: 'Este site é operado pela Dorac Agência ("Dorac", "nós"). Esta Política de Privacidade explica como coletamos, usamos, armazenamos e protegemos os seus dados pessoais quando você visita nosso site ou entra em contato conosco.',
  },
  {
    title: '2. Quais dados coletamos',
    body: 'Coletamos os dados que você nos fornece diretamente ao preencher formulários de contato (nome, e-mail, telefone/WhatsApp, empresa e mensagem), além de dados de navegação coletados automaticamente por cookies e ferramentas de análise, como páginas visitadas, tempo de permanência e origem do acesso.',
  },
  {
    title: '3. Como usamos seus dados',
    body: 'Utilizamos seus dados para responder às suas solicitações de contato e orçamento, entender o comportamento de navegação no site para melhorar nossos conteúdos e ofertas, e, quando aplicável, para ações de marketing sobre os serviços da Dorac. Não vendemos seus dados a terceiros.',
  },
  {
    title: '4. Cookies',
    body: 'Usamos cookies próprios e de terceiros para lembrar suas preferências, entender como o site é utilizado e, quando aplicável, medir a performance de campanhas de marketing. Você pode desativar cookies nas configurações do seu navegador, mas isso pode afetar o funcionamento de algumas partes do site.',
  },
  {
    title: '5. Compartilhamento de dados',
    body: 'Podemos compartilhar seus dados com ferramentas e parceiros que nos ajudam a operar o site e a comunicação (como plataformas de e-mail, WhatsApp Business e ferramentas de análise), sempre limitado ao necessário para prestar o serviço.',
  },
  {
    title: '6. Seus direitos',
    body: 'De acordo com a Lei Geral de Proteção de Dados (LGPD), você pode solicitar a qualquer momento a confirmação, o acesso, a correção ou a exclusão dos seus dados pessoais, bem como revogar consentimentos dados anteriormente. Para isso, entre em contato pelo e-mail comercial@dorac.com.br.',
  },
  {
    title: '7. Segurança',
    body: 'Adotamos medidas técnicas e organizacionais razoáveis para proteger seus dados contra acesso não autorizado, perda ou alteração indevida.',
  },
  {
    title: '8. Alterações nesta política',
    body: 'Esta política pode ser atualizada periodicamente para refletir mudanças em nossas práticas ou na legislação. Recomendamos revisitar esta página de tempos em tempos.',
  },
  {
    title: '9. Contato',
    body: 'S F Dorabiato de Matos LTDA (Agência Dorac), CNPJ 48.809.963/0001-67. Endereço: Rua Professora Diva Proença, 1855 - Sala 03 - Centro, Ivaiporã - PR, CEP 86870-174. E-mail: comercial@dorac.com.br. WhatsApp: +55 43 9665-9096.',
  },
]

function PrivacyPolicyContent() {
  return (
    <section className='dorac-grid-bg pb-24 pt-32'>
      <div className='container mx-auto max-w-3xl px-4'>
        <span className='section-eyebrow'>Transparência</span>
        <h1 className='section-title mb-6'>Política de Privacidade</h1>
        <p className='mb-10 text-sm text-dorac-ink/50'>Última atualização: julho de 2026</p>

        <div className='flex flex-col gap-8'>
          {SECTIONS.map((section) => (
            <div key={section.title}>
              <h2 className='mb-2 text-lg font-bold text-dorac-ink'>{section.title}</h2>
              <p className='text-sm leading-relaxed text-dorac-ink/70'>{section.body}</p>
            </div>
          ))}
        </div>

        <div className='mt-12 border-t border-dorac-border pt-8'>
          <p className='text-sm text-dorac-ink/60'>
            Dúvidas sobre esta política? Fale com a gente pelo e-mail{' '}
            <a href='mailto:comercial@dorac.com.br' className='font-semibold text-dorac-purple'>
              comercial@dorac.com.br
            </a>
            .
          </p>
        </div>
      </div>
    </section>
  )
}

export default PrivacyPolicyContent
